import type { DirectoryUnit } from '@/lib/directory/useDirectory';
import type { Site } from '@/lib/types';
import { SITE_SECTIONS } from '@/pages/sites/status/siteStatusData';

export type SiteUnitBlock = { key: string; label: string | null; units: DirectoryUnit[] };

/**
 * 직원찾기의 현장 소속을 국내 진행 · 해외 진행 · 예정 · 평가 · 준공으로 묶는다(사용자 지시 2026-10-16).
 * 목록과 조직도가 함께 쓴다 — 홈 현장 리스트 · 인력배치표 조직도와 같은 {@link SITE_SECTIONS} 다.
 *
 * <p>묶음 안의 차례는 받은 그대로다(주소록이 준 현장 관리의 차례). 현장 관리에 없는 이름(배치만 남은
 * 옛 현장)은 지우지 않고 맨 뒤에 머리 없이 선다. 빈 묶음은 내지 않는다.
 */
export function siteUnitBlocks(units: DirectoryUnit[], sites: Site[]): SiteUnitBlock[] {
  const siteByName = new Map(sites.map((site) => [site.name, site]));
  const sectionOf = (unit: DirectoryUnit) => {
    const site = siteByName.get(unit.unitName);
    return site ? SITE_SECTIONS.find((section) => section.match(site))?.key : undefined;
  };

  return [
    ...SITE_SECTIONS.map((section) => ({
      key: section.key,
      label: section.label as string | null,
      units: units.filter((unit) => sectionOf(unit) === section.key),
    })),
    { key: 'rest', label: null, units: units.filter((unit) => sectionOf(unit) === undefined) },
  ].filter((block) => block.units.length > 0);
}
